import { Platform } from 'react-native'
import { colors } from '@ui/colors'
import { GradientType } from '@ui/types'

/** Full-width top strip that hosts the prompt + fade over the camera. */
export const MESSAGES_HEIGHT = 240

export const MESSAGES_GRADIENT_DEFAULT = [
  colors.black50,
  colors.black0,
] as const satisfies GradientType

/** Nearly opaque through the prompt, then a short fade — used when the oval would sit under this strip. */
export const MESSAGES_GRADIENT_STRONG = [
  colors.black,
  colors.black,
  colors.black75,
  colors.black0,
] as const satisfies GradientType

export const MESSAGES_GRADIENT_STRONG_LOCATIONS = [0, 0.55, 0.75, 1] as const

export const MESSAGES_CONTAINER_HEIGHT = Platform.select({
  default: 320,
  web: 368,
})

export const MESSAGES_CONTAINER_PADDING_HORIZONTAL = 160
export const MESSAGES_CONTAINER_PADDING_VERTICAL = 64
export const MESSAGES_CONTAINER_BORDER_RADIUS = 24

export const MESSAGES_CONTAINER_INNER_HEIGHT =
  MESSAGES_CONTAINER_HEIGHT - 2 * MESSAGES_CONTAINER_PADDING_VERTICAL

export const ITEM_PADDING_TOP = Platform.select({ default: 24, web: 32 })
export const ITEM_GAP = Platform.select({ default: 24, web: 32 })
export const ITEM_HEIGHT_TEXT = Platform.select({ default: 48, web: 64 })

export const ICON_CONTAINER_SIZE = 64
export const ICON_SIZE = 32

export const PROGRESS_CONTAINER_PADDING_HORIZONTAL = Platform.select({
  default: 32,
  web: 48,
})
export const PROGRESS_CONTAINER_PADDING_BOTTOM = Platform.select({
  default: 24,
  web: 32,
})
export const PROGRESS_BAR_HEIGHT = 8
